import styled from 'styled-components/macro';
import { MiniButton } from '@yme/atoms/mini-button';
import { colorCoreBlack300, colorCoreGray500, colorCoreWhite1000, colorCoreBlack900Base, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel3, HeadingLevel4, RegularTextLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const ContactDescriptionStyled = styled(RegularTextLevel3) `
  margin-top: 8px;
  color: ${colorCoreBlack300};
`;
export const DeliveryDetailsWrapperStyled = styled.div `
  border: 1px solid ${colorCoreGray500};
  border-radius: ${CORNER_RADIUS.s};
`;
export const HeaderStyled = styled.div `
  margin-bottom: 32px;
`;
export const DeliveryItemLabelStyled = styled.div `
  ${getTextStyles('Ubuntu', null, 14, 20)}

  width: 150px;
  gap: 12px;
  color: ${colorCoreBlack300};
`;
export const DeliveryItemValue = styled.div `
  ${getTextStyles('Ubuntu', 400, 14, 20)}

  color: ${colorCoreBlack900Base};
  word-wrap: break-word;
  min-width: 100px;
`;
export const DeliveryDetailsLabelStyled = styled.div `
  padding: 16px;
  display: flex;

  &:not(:last-child) {
    border-bottom: 1px solid ${colorCoreGray500};
  }
`;
export const ContactFormWrapperStyled = styled(FlexWrapper) `
  background-color: ${colorCoreWhite1000};

  ${ADAPTIVE.maxWidth.mobile} {
    margin: 0 -16px 24px;
  }
`;
export const InfoHeading = styled(HeadingLevel4) `
  ${getTextStyles('Ubuntu', 500, 14, 20)}

  color: ${colorCoreBlack300};
`;
export const InfoBlock = styled.div `
  margin-bottom: 32px;
`;
export const HeadingStyled = styled(HeadingLevel3) `
  font-size: 24px;
`;
export const EditButtonStyled = styled.span `
  white-space: nowrap;
  font-weight: 400;
`;
export const EditIconStyled = styled(MiniButton) `
  ${ADAPTIVE.minWidth.mobile} {
    margin-top: 2px;
  }
`;
export const ContactHeading = styled(FlexWrapper) `
  ${ADAPTIVE.minWidth.mobile} {
    align-items: flex-start;
  }
`;
